import { PDFDownloadLink } from '@react-pdf/renderer';
import { ReactElement } from 'react';
import styles from './DownloadPdfLink.module.scss';
import React from 'react';
import classNames from 'classnames';
import { useGetLabelByKey } from 'hooks/useLingUI';

export type DownloadPdfLinkProps = {
  fileName: string;
  document: ReactElement;
  className?: string;
  children?: ReactElement | ReactElement[] | string;
};

export const DownloadPdfLink = ({ fileName, document, className, children }: DownloadPdfLinkProps) => {
  const labelScarica = useGetLabelByKey('scarica');

  return (
    <PDFDownloadLink className={classNames(styles.downloadPdfLink, className)} document={document} fileName={fileName}>
      {children ? children : labelScarica}
    </PDFDownloadLink>
  );
};
